/* Which SOV this is, stated before any number. Two different SOVs exist on
   this platform and a reader who does not know which one is on screen will try
   to reconcile them against the other — which is the one thing neither figure
   supports. */
.provenance {
  display: flex;
  align-items: baseline;
  gap: 10px;
  width: var(--table-w);
  max-width: 100%;
  padding: 9px 14px;
  border: 1px solid var(--border-cell);
  border-left: 3px solid var(--bg-nav-active);
  border-radius: 8px;
  background: #f7f7fd;
  color: #3a3a63;
  font-size: 12px;
  line-height: 17px;
}

.provenance strong {
  flex: none;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.controls { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; justify-content: flex-end; }

.brandCell { display: inline-flex; align-items: center; gap: 7px; }

.clear {
  border: 1px solid var(--border-chip);
  border-radius: var(--radius-pill);
  background: var(--bg-chip);
  padding: 4px 10px;
  color: var(--text-pill);
  font: inherit;
  font-size: 11px;
  line-height: 16px;
  cursor: pointer;
}
.clear:hover { background: #e6effb; }
